// export const GA_TRACKING_ID = 'G-JGM96E6QKV';
// export const GA_TRACKING_ID = 'G-K8ZQP3TMK9';
export const GA_TRACKING_ID = 'G-QBPDPXHHJ1'; 


// Log the pageview with their URL
export const pageview = (url:string) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// Log specific events
export const event = ({ action, params }: any) => {
  window.gtag('event', action, params);
};